import { AppThunk } from '../../../store/types';
import { AuthUserEffects } from '../../../effects/authUserEffects';
import { AuthManager } from '../../../../common/utils/auth-manager';

export class UserAuthCallbackEvents {

  public static onLoad(code: string): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const result = await AuthUserEffects.loginProcess({
        loginHandler: () => {
          return AuthManager.getUserDataByAuthCode(code, true)
        },
        newUserCallback: AuthUserEffects.newUserDefaultHandler,
        targetLangName: '',
        nativeLangName: ''
      });
    }
  }

}
